import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import UserName from '../../common/user/UserName';
import PhoneInput from 'react-phone-input-2';
import ChargeUserModal from '../../common/charge-user/ChargeUserModal';
import Toast from '../../common/toast/Toast';

import { AvailabilityRedirectionContext } from '../../context/availabilityRedirection';
import { SyncButton } from '../../common/sync-button/SyncButton';
import { clearSyncGuestCardMessage, syncGuestCard } from '../../../redux/sync-guestCard/actions/syncGuestCard.action';
import { getLocationTimeZone, visitorHeader } from '../../../constants/constants';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';
import { clearAppointments } from '../../../redux/visitor-list/actions/createAppoinment.action';
import { clearVisitor, getvisitorList } from '../../../redux/visitor-list/actions/visitor-list.action';
import { clearPreviosChargedUserData } from '../../../redux/charge-user/actions/chargeUser.action';
import { visitorObj } from '../interface/Visitor.interface';

import Loader from '../../common/loader/Loader';

import iconPagination from '../../../images/icon-chevron-left.svg';
import SearchIcon from '../../../images/icon-search.svg';
import dollar from '../../../images/dollar.png';
import NoUnits from '../../../images/no-units-found.svg';
import CalendarIcon from '../../../images/calendar-icon.svg';
import FilterIcon from '../../svgIcons/FilterIcon';

import styles from './visitorListing.module.css';

import Select, { SelectItemRenderer } from 'react-dropdown-select';

import { hasPermission, Option } from '../../auth/login/Login';
import MageDotsIcon from '../../svgIcons/MageDotsIcon';
import { activateUser, deactivateUser } from '../../../redux/user-management/actions/userManagement.actions';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-phone-input-2/lib/style.css';

function visitorListing() {
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const permissionLoading = useSelector((state: IRootState) => state?.permissionsReducer?.loading);
    const canCreateAppointment = hasPermission('Self-Guided Tours', 'Appointments', 'create');
    const canCreateVisitor = hasPermission('Visitors', 'Visitor', 'create');
    const canReadVisitor = hasPermission('Visitors', 'Visitor', 'read');
    const canDeleteVisitor = hasPermission('Visitors', 'Visitor', 'delete');
    const canUpdateVisitor = hasPermission('Visitors', 'Visitor', 'update');

    const availabilityRedirectionContext = useContext(AvailabilityRedirectionContext);
    const data = useSelector((state: IRootState) => state.VisitorListReducer.data.data);
    const VisitorListsCounts = useSelector((state: IRootState) => state?.VisitorListReducer.data.count);
    const VisitorListApplicationStartDate = useSelector((state: IRootState) => state?.VisitorListReducer.data.applicationStartDate);
    const VisitorApplicationListEndDate = useSelector((state: IRootState) => state?.VisitorListReducer.data.applicationEndDate);
    const VisitorListLeaseStartDate = useSelector((state: IRootState) => state?.VisitorListReducer.data.leaseStartDate);
    const VisitorLeaseListEndDate = useSelector((state: IRootState) => state?.VisitorListReducer.data.leaseEndDate);
    const loading = useSelector((state: IRootState) => state?.VisitorListReducer.loading);
    const chargeUserData = useSelector((state: IRootState) => state.chargeUser.data);
    const syncGuestCardData = useSelector((state: IRootState) => state.syncGuestCardReducer.data);
    const syncGuestCardLoading = useSelector((state: IRootState) => state.syncGuestCardReducer.loading);

    const pageNumberLimit = 5;

    const [currentPage, setCurrentPage] = useState(+1);
    const [totalPages, setTotalPages] = useState(Math.ceil(VisitorListsCounts / 10));
    const [maxPageLimit, setMaxPageLimit] = useState(5);
    const [minPageLimit, setMinPageLimit] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [searchUser, setSearchUser] = useState<null | string>(null);
    const [showChargeModal, setShowChargeModal] = useState(false);
    const [customerId, setCustomerId] = useState('');
    const [userId, setUserId] = useState('');
    const [visitorsData, setVisitorsData] = useState([]);
    const [index, setIndex] = useState<number>(-1);
    const [chargeUserMessage, setChargeUserMessage] = useState({
        message: '',
        type: '',
    });
    const [syncGuestCardMessage, setSyncGuestCardMessage] = useState({
        message: '',
        type: '',
    });

    const [showFilter, setShowFilter] = useState<boolean>(false);
    const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
    const [startDate, setStartDate] = useState<string | null>(null);
    const [endDate, setEndDate] = useState<string | null>(null);

    const [leaseDateRange, setLeaseDateRange] = useState<[Date | null, Date | null]>([null, null]);
    const [leaseStartDate, setLeaseStartDate] = useState<string | null>(null);
    const [leaseEndDate, setLeaseEndDate] = useState<string | null>(null);

    const [filterApplied, setFilterApplied] = useState<boolean>(false);
    const pmsTypes: Option[] = [
        { label: 'yardi', value: 'yardi' },
        { label: 'Realpage onesite', value: 'REALPAGE_ONESITE' },
        { label: 'entrata', value: 'entrata' },
        { label: 'resman', value: 'resman' },
    ];

    const [selectedPMSTypes, setSelectedPMSTypes] = useState<Option[]>([]);
    const [selectedPMSNames, setSelectedPMSNames] = useState<string[]>([]);
    const [isAllPMSSelected, setIsAllPMSSelected] = useState(true);

    const [showActionBox, setShowActionBox] = useState('');
    const [actionBoxPosition, setActionBoxPosition] = useState<'top' | 'bottom'>('bottom');
    const actionButtonRefs = useRef<Record<string, HTMLTableRowElement | null>>({});

    const [isLoading, setIsLoading] = useState(false);

    const [toastType, setToastType] = useState('error');
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState<string | null>(null);

    useEffect(() => {
        setSyncGuestCardMessage({
            message: '',
            type: '',
        });
        dispatch(clearPreviosChargedUserData());
    }, []);

    useEffect(() => {
        if (data) {
            setVisitorsData(data);
        }
    }, [data]);

    useEffect(() => {
        if (
            syncGuestCardData &&
            Object.keys(syncGuestCardData).length &&
            syncGuestCardData.statusCode === 200 &&
            !syncGuestCardLoading &&
            !loading &&
            index !== -1
        ) {
            if (syncGuestCardData.status === true) {
                setSyncGuestCardMessage({
                    message: syncGuestCardData.message,
                    type: 'success',
                });
                data[index].realPageGuestCardId = syncGuestCardData.guestCardId;
            } else {
                setSyncGuestCardMessage({
                    message: syncGuestCardData.message,
                    type: 'error',
                });
            }
        }
    }, [syncGuestCardData, syncGuestCardLoading, loading, index]);

    useEffect(() => {
        setChargeUserMessage({ message: '', type: '' });
        if (chargeUserData && Object.keys(chargeUserData).length) {
            if (chargeUserData.statusCode === 201) {
                setChargeUserMessage({ message: chargeUserData.message, type: 'success' });
            } else {
                setChargeUserMessage({ message: chargeUserData.message, type: 'error' });
            }
        }
    }, [chargeUserData]);

    const fetchVisitorList = (
        page: number,
        searchUser: string,
        startDate: null | string,
        endDate: null | string,
        leaseStartDate: string | null,
        leaseEndDate: string | null,
        selectedPMSDetails: string[] | [],
    ) => {
        if (filterApplied && searchUser === '') {
            setFilterApplied(false);
            dispatch(
                getvisitorList({
                    page: 1,
                    limit: 10,
                    searchText: searchUser?.trim(),
                    applicationStartDate: startDate || '',
                    applicationEndDate: endDate || '',
                    leaseStartDate: leaseStartDate || '',
                    leaseEndDate: leaseEndDate || '',
                    pmsNames: selectedPMSDetails,
                }),
            );
        } else {
            dispatch(
                getvisitorList({
                    page: page,
                    limit: 10,
                    searchText: searchUser?.trim(),
                    applicationStartDate: startDate || '',
                    applicationEndDate: endDate || '',
                    leaseStartDate: leaseStartDate || '',
                    leaseEndDate: leaseEndDate || '',
                    pmsNames: selectedPMSDetails,
                }),
            );
        }
    };

    useEffect(() => {
        fetchVisitorList(
            currentPage,
            searchUser || '',
            startDate ? moment(startDate).format('MM-DD-YYYY') : '',
            endDate ? moment(endDate).format('MM-DD-YYYY') : '',
            leaseStartDate ? moment(leaseStartDate).format('MM-DD-YYYY') : '',
            leaseEndDate ? moment(leaseEndDate).format('MM-DD-YYYY') : '',
            selectedPMSNames ? selectedPMSNames : [],
        );
    }, [searchUser, currentPage, startDate, endDate, leaseStartDate, leaseEndDate, selectedPMSNames]);

    useEffect(() => {
        if (maxPageLimit > totalPages) {
            setMaxPageLimit(totalPages);
        }
    }, [maxPageLimit > totalPages]);

    const handlePageClick = (e: React.MouseEvent<HTMLSpanElement>) => {
        dispatch(clearSyncGuestCardMessage());
        setSyncGuestCardMessage({ message: '', type: '' });
        setCurrentPage(+(e.target as HTMLSpanElement).id);
    };

    const totalPageLength = [];
    for (let i = 0; i <= VisitorListsCounts; i++) {
        totalPageLength.push(i);
    }

    const pageNumbers = totalPageLength.map((page, number: number) => {
        if (page <= maxPageLimit && page > minPageLimit) {
            return (
                <span key={page} id={String(number)} onClick={handlePageClick} className={currentPage === page ? `${styles.active}` : ``}>
                    {page}
                </span>
            );
        }
        return null;
    });

    const handlePrevClick = () => {
        dispatch(clearSyncGuestCardMessage());
        if (currentPage > 1) {
            if ((currentPage - 1) % pageNumberLimit === 0) {
                const min = minPageLimit;
                setMaxPageLimit(min);
                setMinPageLimit(minPageLimit - pageNumberLimit);
            }
            setCurrentPage((prev) => +prev - 1);
        }
    };

    const handleNextClick = () => {
        dispatch(clearSyncGuestCardMessage());
        if (currentPage !== totalPages) {
            if (currentPage + 1 > maxPageLimit) {
                setMaxPageLimit(maxPageLimit + pageNumberLimit);
                setMinPageLimit(minPageLimit + pageNumberLimit);
            }
            setCurrentPage((prev) => +prev + 1);
        }
    };

    useEffect(() => {
        const pageCount = Math.ceil(VisitorListsCounts / 10);
        setTotalPages(pageCount);
        setMaxPageLimit(pageCount > 5 ? 5 : pageCount);
    }, [VisitorListsCounts]);

    const searchHandler = async (e: React.FormEvent) => {
        e.preventDefault();
        setFilterApplied(true);
        setCurrentPage(1);
        setMinPageLimit(0);
        setMaxPageLimit(5);
        dispatch(clearSyncGuestCardMessage());
        setSyncGuestCardMessage({ message: '', type: '' });
        setSearchUser(searchText);
    };

    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        const { value } = e.target as HTMLInputElement;
        setSearchText(value);

        if (filterApplied && value === '') {
            setSearchUser('');
            setMinPageLimit(0);
            setMaxPageLimit(5);
            setCurrentPage(1);
        }
    };

    const handleSearchItem = (id: string) => {
        dispatch(clearVisitor());
        navigate(`/create-visitor`, {
            state: { type: 'Edit', id: id },
        });
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === ' ' && String(searchText).length === 0) {
            event.preventDefault();
        }
    };

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '600px',
        },
    };

    const clickHandler = (email: string, locationId: string | null, index: number) => {
        setIndex(index);
        if (email && locationId) {
            dispatch(syncGuestCard({ email, locationId }, currentPage, 10, searchText));
        }
    };

    const clearFilter = () => {
        setDateRange([null, null]);
        setLeaseDateRange([null, null]);
        setShowFilter(false);
        if (
            (!!VisitorListApplicationStartDate && !!VisitorApplicationListEndDate) ||
            (!!VisitorLeaseListEndDate && !!VisitorListLeaseStartDate)
        ) {
            setCurrentPage(1);
            setStartDate(null);
            setEndDate(null);
            setLeaseStartDate(null);
            setLeaseEndDate(null);
            setMinPageLimit(0);
            setMaxPageLimit(5);
        }
    };

    const onCancel = () => {
        setShowFilter(false);
        setDateRange([
            VisitorListApplicationStartDate !== '' ? new Date(VisitorListApplicationStartDate) : null,
            VisitorApplicationListEndDate !== '' ? new Date(VisitorApplicationListEndDate) : null,
        ]);
        setLeaseDateRange([
            VisitorListLeaseStartDate !== '' ? new Date(VisitorListLeaseStartDate) : null,
            VisitorLeaseListEndDate !== '' ? new Date(VisitorLeaseListEndDate) : null,
        ]);
        const resetPMSType = pmsTypes.filter((value: Option) => selectedPMSNames.includes(value.value));
        setSelectedPMSTypes(resetPMSType || []);
    };

    const onDateFilter = () => {
        const selectedPMSDetails: string[] = selectedPMSTypes.map((PMS: Option) => PMS.value) || [];
        setSelectedPMSNames(selectedPMSDetails);
        setShowFilter(false);
        dispatch(clearSyncGuestCardMessage());
        setSyncGuestCardMessage({ message: '', type: '' });
        setCurrentPage(1);
        setMinPageLimit(0);
        setMaxPageLimit(5);
        setStartDate(dateRange[0] !== null ? moment(dateRange[0]).format('MM-DD-YYYY') : '');
        setEndDate(dateRange[1] !== null ? moment(dateRange[1]).format('MM-DD-YYYY') : '');
        setLeaseStartDate(leaseDateRange[0] !== null ? moment(leaseDateRange[0]).format('MM-DD-YYYY') : '');
        setLeaseEndDate(leaseDateRange[1] !== null ? moment(leaseDateRange[1]).format('MM-DD-YYYY') : '');
    };

    const customContentRenderer = ({ props, state }: any) =>
        state.values?.length ? (
            <div style={{ cursor: 'pointer' }}>
                {state.values.length} of {props.options.length} PMS selected
            </div>
        ) : (
            <div className={styles.placeholder}>
                <span>Select PMS</span>
            </div>
        );

    const itemRenderer = (props: SelectItemRenderer<Option>) => {
        const { item } = props;
        return (
            <div className={styles.boxes}>
                <input type="checkbox" id={item?.label} />
                <label htmlFor={item?.label}>{item?.value}</label>
            </div>
        );
    };

    const customDropdownRenderer = ({ props, state, methods }: any) => {
        const regexp = new RegExp(state.search, 'i');

        if (state?.values?.length !== state?.searchResults?.length) {
            setIsAllPMSSelected(false);
        }
        if (state?.values?.length === state?.searchResults?.length) {
            setIsAllPMSSelected(true);
        }

        return (
            <div className={styles.customDropdownMenu}>
                {
                    <div className={styles.inlineItems}>
                        <div className={styles.boxes}>
                            <input
                                type="checkbox"
                                id="selectAll"
                                checked={isAllPMSSelected}
                                onChange={(e) => {
                                    setIsAllPMSSelected(e?.target?.checked);
                                    e?.target?.checked ? methods?.selectAll() : methods?.clearAll();
                                }}
                            />
                            <label htmlFor="selectAll">Select All</label>
                        </div>
                        <button className={styles.clearBtn} onClick={() => methods?.clearAll()}>
                            Clear All
                        </button>
                    </div>
                }
                <div className={styles.listContainer}>
                    {props.options
                        .filter((item: any) => regexp.test(item[props.searchBy] || item[props.labelField]))
                        .map((option: any) => {
                            if (!props.keepSelectedInList && methods.isSelected(option)) {
                                return null;
                            }

                            return (
                                <div key={option[props.valueField]} className={styles.boxes}>
                                    <input
                                        type="checkbox"
                                        id={option[props.labelField]}
                                        onChange={() => (option.disabled ? undefined : methods.addItem(option))}
                                        checked={methods.isSelected(option)}
                                    />
                                    <label htmlFor={option[props.labelField]}>{option[props.labelField]}</label>
                                </div>
                            );
                        })}
                </div>
            </div>
        );
    };

    const handleActionButtonClick = (userId: string, index: number) => {
        if (visitorListing?.length > 2) {
            setActionBoxPosition(index > 1 ? 'top' : 'bottom');
        } else {
            setActionBoxPosition('top');
        }

        setShowActionBox(showActionBox !== userId ? userId : '');
    };

    useEffect(() => {
        if (toastType) {
            setTimeout(() => {
                setShowToast(false);
            }, 4000);
        }
    }, [showToast]);

    useEffect(() => {
        if (toastType) {
            setTimeout(() => {
                setShowToast(false);
            }, 4000);
        }
    }, [showToast]);

    const onActivateSuccess = async (message: string) => {
        setToastMessage(message);
        setShowToast(true);
        setToastType('success');
        fetchVisitorList(
            currentPage,
            searchUser || '',
            startDate ? moment(startDate).format('MM-DD-YYYY') : '',
            endDate ? moment(endDate).format('MM-DD-YYYY') : '',
            leaseStartDate ? moment(leaseStartDate).format('MM-DD-YYYY') : '',
            leaseEndDate ? moment(leaseEndDate).format('MM-DD-YYYY') : '',
            selectedPMSNames ? selectedPMSNames : [],
        );
        setIsLoading(false);
    };

    const onActivateFailure = (message: string) => {
        setIsLoading(false);
        setToastMessage(message);
        setShowToast(true);
        setToastType('error');
    };

    const onActivate = (userId: string) => {
        setIsLoading(true);
        dispatch(activateUser(userId, onActivateSuccess, onActivateFailure));
    };

    const onDeactivateSuccess = async (message: string) => {
        setToastMessage(message);
        setShowToast(true);
        setToastType('success');
        fetchVisitorList(
            currentPage,
            searchUser || '',
            startDate ? moment(startDate).format('MM-DD-YYYY') : '',
            endDate ? moment(endDate).format('MM-DD-YYYY') : '',
            leaseStartDate ? moment(leaseStartDate).format('MM-DD-YYYY') : '',
            leaseEndDate ? moment(leaseEndDate).format('MM-DD-YYYY') : '',
            selectedPMSNames ? selectedPMSNames : [],
        );
        setIsLoading(false);
    };

    const onDeactivateFailure = (message: string) => {
        setIsLoading(false);
        setToastMessage(message);
        setShowToast(true);
        setToastType('error');
    };

    const onDeactivate = (userId: string) => {
        if (userId) {
            setIsLoading(true);
            dispatch(deactivateUser(userId, onDeactivateSuccess, onDeactivateFailure));
        }
    };

    return (
        <React.Fragment>
            {(loading || isLoading || permissionLoading) && <Loader />}
            {chargeUserMessage.message && <Toast message={chargeUserMessage.message} type={chargeUserMessage.type} />}

            {syncGuestCardMessage.message && syncGuestCardMessage.type && !loading && !syncGuestCardLoading && (
                <Toast message={syncGuestCardMessage.message} type={syncGuestCardMessage.type} />
            )}

            {showChargeModal && (
                <Modal
                    appElement={document.getElementById('root') as HTMLElement}
                    onRequestClose={() => setShowChargeModal(false)}
                    style={customStyles}
                    isOpen={showChargeModal}>
                    <ChargeUserModal customerId={customerId} userId={userId} setShowChargeModal={setShowChargeModal} />
                </Modal>
            )}
            <div className={`${styles.visitorPadding} outletConainer`}>
                <div className={styles.visitorHead}>
                    <div className={styles.userGreet}>
                        <p>
                            Welcome <UserName />
                        </p>
                        <h2>Visitors</h2>
                    </div>
                    <div className={styles.btnContainer}>
                        <div className={styles.filterWrapper}>
                            {canReadVisitor && (
                                <button className={styles.filterIconWrapper} onClick={() => setShowFilter(!showFilter)}>
                                    <FilterIcon />
                                    {(!!VisitorListApplicationStartDate && !!VisitorApplicationListEndDate) ||
                                        (!!VisitorListLeaseStartDate && !!VisitorLeaseListEndDate) ? (
                                        <span className={styles.active}></span>
                                    ) : null}
                                </button>
                            )}
                            {showFilter && <div className={styles.filterBackDrop} onClick={onCancel}></div>}
                            {showFilter && (
                                <div className={`${styles.filterMenuWrapper} ${showFilter ? styles.showFilter : ''}`}>
                                    <div className={styles.dropDownWrapper}>
                                        <Select
                                            className={styles.customReactSelectDropdown}
                                            options={pmsTypes}
                                            multi
                                            closeOnClickInput
                                            values={selectedPMSTypes}
                                            keepSelectedInList
                                            onChange={(values: Option[]) => {
                                                if (values) {
                                                    setSelectedPMSTypes(values);
                                                }
                                            }}
                                            onSelect={() => null}
                                            onDeselect={() => null}
                                            clearable={false}
                                            contentRenderer={customContentRenderer}
                                            itemRenderer={itemRenderer}
                                            dropdownRenderer={customDropdownRenderer}
                                        />
                                    </div>

                                    <h3> Select Application event date</h3>
                                    <div className={`${styles.datePickerWrapper} datePicker-wrapper`}>
                                        <DatePicker
                                            selected={(dateRange && dateRange[0]) || null}
                                            dateFormat="MMM dd, yyyy"
                                            showPopperArrow={false}
                                            timeIntervals={30}
                                            placeholderText="Start Date - End Date"
                                            name="Start Date"
                                            className={`${styles.customDatePicker} custom-dateInput`}
                                            isClearable={false}
                                            selectsRange={true}
                                            startDate={dateRange[0] || null}
                                            endDate={dateRange[1] || null}
                                            onChange={(applicationDate) => {
                                                setDateRange(applicationDate);
                                            }}
                                            onCalendarClose={() => {
                                                if (dateRange && dateRange[1] === null) {
                                                    setDateRange([dateRange[0], dateRange[0]]);
                                                }
                                            }}
                                        />
                                        <img src={CalendarIcon} alt="calendar" />
                                    </div>

                                    <h3 className={styles.mt}>Select Lease event date</h3>
                                    <div className={`${styles.datePickerWrapper} datePicker-wrapper`}>
                                        <DatePicker
                                            selected={(leaseDateRange && leaseDateRange[0]) || null}
                                            dateFormat="MMM dd, yyyy"
                                            showPopperArrow={false}
                                            timeIntervals={30}
                                            placeholderText="Start Date - End Date"
                                            name="Start Date"
                                            className={`${styles.customDatePicker} custom-dateInput`}
                                            isClearable={false}
                                            selectsRange={true}
                                            startDate={leaseDateRange[0] || null}
                                            endDate={leaseDateRange[1] || null}
                                            onChange={(e) => {
                                                setLeaseDateRange(e);
                                            }}
                                            onCalendarClose={() => {
                                                if (leaseDateRange && leaseDateRange[1] === null) {
                                                    setLeaseDateRange([leaseDateRange[0], leaseDateRange[0]]);
                                                }
                                            }}
                                        />
                                        <img src={CalendarIcon} alt="calendar" />
                                    </div>

                                    <div className={styles.filterBtnWrapper}>
                                        <button
                                            onClick={() =>
                                                dateRange[0] === null && leaseDateRange[0] === null ? onCancel() : clearFilter()
                                            }>
                                            {' '}
                                            {dateRange[0] === null && leaseDateRange[0] === null ? 'Cancel' : 'Clear'}
                                        </button>
                                        <button className={styles.btnGreen} onClick={onDateFilter}>
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {canCreateVisitor && (
                            <button
                                className={styles.btnWhite}
                                onClick={() => {
                                    dispatch(clearSyncGuestCardMessage());
                                    dispatch(clearVisitor());
                                    navigate(`/create-visitor`, {
                                        state: { type: 'Add' },
                                    });
                                }}>
                                Create a visitor
                            </button>
                        )}

                        {canCreateAppointment && (
                            <button
                                className={styles.btnGreen}
                                onClick={() => {
                                    availabilityRedirectionContext?.setStep?.(1);
                                    availabilityRedirectionContext?.setAvailabilityData?.({
                                        locationId: '',
                                        locationName: '',
                                        selectedDate: '',
                                        slotRange: '',
                                        unitId: '',
                                        unitName: '',
                                        lockerNumber: 0,
                                    });
                                    availabilityRedirectionContext?.setSelectedUserTableData?.({
                                        bedrooms: '',
                                        companyName: '',
                                        contact: '',
                                        countryCode: '',
                                        date: '',
                                        email: '',
                                        locationName: '',
                                        name: '',
                                    });
                                    availabilityRedirectionContext?.setLocationDetails?.({
                                        city: '',
                                        description: '',
                                        id: '',
                                        images: [],
                                        name: '',
                                        provisioningId: '',
                                        state: '',
                                        street1: '',
                                        street2: '',
                                        streetNumber: '',
                                        timeZone: '',
                                        zip: '',
                                        lockerName: '',
                                    });
                                    availabilityRedirectionContext?.setUserId?.('');
                                    availabilityRedirectionContext?.setData?.([]);
                                    dispatch(clearAppointments());
                                    navigate(`/create-appointment`);
                                }}>
                                Create Appointment
                            </button>
                        )}
                    </div>
                </div>

                {canReadVisitor && (
                    <form onSubmit={searchHandler} className={styles.searchContainer}>
                        <div className={styles.searchBox}>
                            <input
                                onKeyPress={handleKeyPress}
                                value={searchText}
                                onChange={(e) => handleChange(e)}
                                onPaste={(e: React.ClipboardEvent) => {
                                    e.preventDefault();
                                    const pastedValue = e?.clipboardData?.getData('text/plain');
                                    setSearchText(pastedValue?.trimEnd());
                                }}
                                type="text"
                                placeholder="Search for visitor by name, email, contact , property or Company"
                                maxLength={50}
                            />
                            <img className={styles.searchIconImage} src={SearchIcon} alt="search-icon" />
                            <button
                                type="submit"
                                className={searchText !== '' && searchText?.length > 3 ? 'active' : ''}
                                disabled={!(searchText !== '' && searchText?.length > 3)}>
                                Search
                            </button>
                        </div>
                    </form>
                )}
                {canReadVisitor && (
                    <div className={styles.visitorListing}>
                        <table className={`${styles.visitorTable} visitorListing`}>
                            <thead>
                                <tr>
                                    {visitorHeader.map((item, index) => {
                                        return <th key={index}>{item.title}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {visitorsData && !!visitorsData.length
                                    ? visitorsData.map((item: visitorObj, index: number) => {
                                        return (
                                            <tr key={index} className={`${item?.deActivateDate !== null ? styles.deactivated : ''}`}>
                                                <td>{`${item.firstName}  ${item.lastName}`}</td>
                                                <td>{item.email}</td>
                                                <td className="phone-col">
                                                    <PhoneInput
                                                        value={String(`+${item.countryCode}${item.phoneNumber || ''}`)}
                                                        disabled
                                                    />
                                                </td>
                                                <td>{item.locationName}</td>
                                                <td>{item.pmsLeadSorce ? item.pmsLeadSorce.lead_name : ''}</td>
                                                <td>
                                                    {item.expectedMoveInDate &&
                                                        moment(item.expectedMoveInDate).utc().locale('en').format('MM-DD-YYYY ')}
                                                </td>
                                                <td>
                                                    {item.desiredNumBedrooms === '0' || item.desiredNumBedrooms === 'Studio'
                                                        ? 'Studio'
                                                        : item.desiredNumBedrooms}
                                                </td>
                                                <td>{item.applicationEventDate ? item?.applicationEventDate : ''}</td>
                                                <td>{item.leaseSignEventDate ? item?.leaseSignEventDate : ''}</td>
                                                <td>{item.companyName}</td>
                                                <td>
                                                    <div className={styles.timezonewrapper}>
                                                        <p>
                                                            {item?.created_at
                                                                ? moment
                                                                    .utc(item.created_at)
                                                                    .tz(item?.timeZone || 'America/New_York') // Default to EST if timeZone is null or empty
                                                                    .format('MM-DD-YYYY hh:mm A')
                                                                : ''}
                                                        </p>

                                                        <span>{getLocationTimeZone(item?.timeZone) || 'America/New_York'}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    {item.stripeCustomerId && (
                                                        <img
                                                            onClick={() => {
                                                                setShowChargeModal(true);
                                                                setCustomerId(item.stripeCustomerId);
                                                                setUserId(item.id);
                                                            }}
                                                            className={styles.editIcon}
                                                            width={18}
                                                            height={18}
                                                            src={dollar}
                                                            alt="charge"
                                                        />
                                                    )}
                                                </td>
                                                <td onClick={() => clickHandler(item.email, item.locationId, index)}>
                                                    <SyncButton
                                                        guestCardId={item.realPageGuestCardId}
                                                        syncGuestCardLoading={syncGuestCardLoading}
                                                    />
                                                </td>
                                                <td>{item?.stripeCustomerId?.trim() ? 'Yes' : 'No'}</td>
                                                <td>{item?.stripeDocVerificationClientId?.trim() ? 'Yes' : 'No'}</td>
                                                <td>{item?.terms === 1 ? 'Yes' : 'No'}</td>
                                                <td>
                                                    {/* <img
                                                    src={EditIcon}
                                                    alt="edit icon"
                                                    width={18}
                                                    height={18}
                                                    className={styles.editIcon}
                                                    onClick={() => {
                                                        setChargeUserMessage({ message: '', type: '' });
                                                        handleSearchItem(item.id);
                                                        dispatch(clearVisitor());
                                                    }}
                                                /> */}

                                                    {!!showActionBox && (
                                                        <div
                                                            className={styles.dropDownBackDrop}
                                                            onClick={() => setShowActionBox('')}></div>
                                                    )}
                                                    {(canDeleteVisitor || canUpdateVisitor) && item.deleted_at === null && (
                                                        <div className={styles.actionButtonWrapper}>
                                                            <button
                                                                className={styles.MageDotsIcon}
                                                                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                                                    event.stopPropagation();
                                                                    handleActionButtonClick(item?.id, index);
                                                                }}>
                                                                <MageDotsIcon />
                                                            </button>
                                                            <div
                                                                className={`${styles.actionContainer} ${item?.id === showActionBox ? styles.active : ''
                                                                    } ${actionBoxPosition === 'top' ? styles.top : ''}`}>
                                                                {canUpdateVisitor && (
                                                                    <div
                                                                        className={styles.actionBox}
                                                                        role="button"
                                                                        onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                                                                            event.stopPropagation();
                                                                            setChargeUserMessage({ message: '', type: '' });
                                                                            handleSearchItem(item.id);
                                                                            dispatch(clearVisitor());
                                                                            setShowActionBox('');
                                                                        }}>
                                                                        <span>Edit</span>
                                                                    </div>
                                                                )}

                                                                {canDeleteVisitor && item.deActivateDate === null && (
                                                                    <div
                                                                        className={styles.actionBox}
                                                                        role="button"
                                                                        onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                                                                            event.stopPropagation();
                                                                            onDeactivate(item.id);
                                                                            setShowActionBox('');
                                                                        }}>
                                                                        <span>Deactivate</span>
                                                                    </div>
                                                                )}

                                                                {canDeleteVisitor && item?.deActivateDate && (
                                                                    <div
                                                                        className={styles.actionBox}
                                                                        role="button"
                                                                        onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                                                                            event.stopPropagation();
                                                                            onActivate(item.id);
                                                                            setShowActionBox('');
                                                                        }}>
                                                                        <span>Activate</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })
                                    : !loading && (
                                        <tr>
                                            <td colSpan={14} style={{ textAlign: 'center' }}>
                                                <div className={styles.noUnits}>
                                                    <img src={NoUnits} alt="no-units" />
                                                    <p className={styles.noUnitsFoundText}>No Records Found</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>
                )}
                {canReadVisitor && !!visitorsData?.length && !loading && (
                    <div>
                        <div className={styles.pagination}>
                            <span className={`${styles.back} ${styles.action}`} onClick={handlePrevClick}>
                                <img src={iconPagination} alt="Previous" />
                            </span>
                            {pageNumbers}
                            <span className={`${styles.next} ${styles.action}`} onClick={handleNextClick}>
                                <img src={iconPagination} alt="Next" />
                            </span>
                        </div>
                    </div>
                )}
            </div>
            {showToast && <Toast type={toastType} message={toastMessage || ''} />}
        </React.Fragment>
    );
}

export default visitorListing;
